'use client';
import { useWindowOpen } from '@repo/platform';
import { cn } from '@repo/ui';
import { TextButton } from '@repo/ui';
import Link from 'next/link';

import { useIsDeeplinkFallback } from '@/hooks/useIsDeeplinkFallback';
import { SERVICE_LINKS } from '@/lib/constants/common';

export const IMCBanner = () => {
  const isDeeplinkFallback = useIsDeeplinkFallback();
  const { openWindow } = useWindowOpen();

  if (isDeeplinkFallback) return null;

  return (
    <div className="w-full flex flex-col justify-center items-center ss:container-padding-large mt-tiny-large ss:mt-normal-xlarge">
      <section className="relative group container-xlarge ss:rounded-bzc-medium lg:rounded-bzc-xlarge overflow-hidden">
        <Link href={'https://ab.bznav.com/zczou49'} className={cn('flex lg:rounded-[40px] overflow-hidden')} target={'_blank'} rel={'noopener noreferrer'}>
          <picture className="w-full">
            <source srcSet={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/brand/image/img_imc-rsr-bznav-pc.png`} media="(min-width: 480px)" />
            <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/brand/image/img_imc-rsr-bznav-mo.png`} alt="비즈넵 배너" className="w-full" />
          </picture>
        </Link>
        <div className="hidden lg:block absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
          <TextButton
            variant="secondary"
            size="medium"
            style={{ borderRadius: '9999px' }}
            className="bg-white/90 backdrop-blur-lg text-neutral-foreground-main border border-white/40 elevation-small"
            onClick={() => openWindow(SERVICE_LINKS['bznav-refund'])}
          >
            bzr; 바로가기
          </TextButton>
        </div>
      </section>
    </div>
  );
};
